"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CONTROLS : CONTROL : STYLES --------------- ++++++++++ */


var _default = {
  iconcontrol: {
    height: (0, _index.pxToEm)(136),
    width: (0, _index.pxToEm)(140),
    border: "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.neutral.light.swatch, " solid"),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'filter .15s ease-in 0s',
    borderRadius: (0, _index.pxToEm)(12),
    marginRight: (0, _index.pxToEm)(8),
    '&:hover': {
      filter: 'brightness(83%)'
    },
    '&:last-child': {
      marginRight: '0px'
    },
    '& .content': {
      width: (0, _index.pxToEm)(64),
      height: '100%',
      textAlign: 'center',
      zIndex: '5',
      position: 'relative',
      '& .moderationimg': {
        width: '100%',
        height: (0, _index.pxToEm)(64),
        marginTop: (0, _index.pxToEm)(24),
        borderRadius: (0, _index.pxToEm)(32),
        backgroundColor: 'rgba(129, 201, 255, 0.09)'
      },
      '& .moderationtype': {
        width: '100%',
        color: function color(props) {
          return props.selected ? _index.theme.color.primary.medium.swatch : _index.theme.color.supporting.dark.swatch;
        },
        fontSize: (0, _index.pxToEm)(16),
        fontWeight: '500',
        marginTop: (0, _index.pxToEm)(4),
        lineHeight: (0, _index.pxToEm)(24),
        marginBottom: (0, _index.pxToEm)(16)
      }
    },
    '& .trianglecontainer': {
      width: '100%',
      display: function display(props) {
        return props.selected ? 'block' : 'none';
      },
      '& .triangle': {
        width: (0, _index.pxToEm)(56),
        height: (0, _index.pxToEm)(56),
        border: "".concat((0, _index.pxToEm)(28), " solid"),
        borderRadius: (0, _index.replacePXinStringWithEM)('0px 12px 0px 0px'),
        borderColor: function borderColor(props) {
          return props.selected ? "".concat(_index.theme.color.primary.medium.swatch, " ").concat(_index.theme.color.primary.medium.swatch, " transparent transparent") : "".concat(_index.theme.color.light.light.swatch, " ").concat(_index.theme.color.light.light.swatch, " transparent transparent");
        },
        marginLeft: 'auto',
        position: 'relative',
        zIndex: 3,
        top: '-136.5px',
        right: '-37.5px',
        '& .icon': {
          width: '16px',
          height: '16px',
          fontSize: '12px',
          position: 'relative',
          color: _index.theme.color.light.light.swatch,
          top: '-22px',
          right: '-5px',
          zIndex: 4
        }
      }
    },
    '&.selected-true': {
      color: _index.theme.color.primary.medium.swatch,
      boxShadow: _index.theme.boxShadow.inset,
      border: "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.primary.medium.swatch, " solid"),
      backgroundColor: 'rgba(129, 201, 255, 0.09)',
      '&:hover': {
        filter: 'brightness(98%)'
      }
    }
  }
};
exports.default = _default;